import React from 'react';
import { FaUserCircle, FaTimes, FaPaperPlane } from 'react-icons/fa';
import QuestionPalette from './QuestionPalette';

const MobileQuestionModal = ({
  show,
  email,
  questions,
  markedbackup,
  savedbackup,
  visitedbackup,
  currentQuestionIndex,
  onHide,
  onQuestionSelect,
  onSubmit,
}) => {
  if (!show) return null;

  return (
    <div className="mobile-navigator" role="dialog" aria-modal="true" aria-label="Question navigator">
      <div className="mobile-navigator__backdrop" onClick={onHide} />
      <aside className="mobile-navigator__panel">
        <div className="mobile-navigator__header">
          <div className="mobile-user">
            <FaUserCircle />
            <div>
              <strong>Candidate</strong>
              <span>{email}</span>
            </div>
          </div>
          <button type="button" className="icon-button" onClick={onHide} aria-label="Close">
            <FaTimes />
          </button>
        </div>

        <div className="mobile-navigator__body">
          <div className="navigator-title">Question Navigator</div>
          <QuestionPalette
            mobile
            questions={questions}
            markedbackup={markedbackup}
            savedbackup={savedbackup}
            visitedbackup={visitedbackup}
            currentQuestionIndex={currentQuestionIndex}
            onQuestionSelect={onQuestionSelect}
          />
        </div>

        <button type="button" className="mobile-submit" onClick={onSubmit}>
          <FaPaperPlane /> Submit Test
        </button>
      </aside>
    </div>
  );
};

export default MobileQuestionModal;
